import {CPSConstants} from "commonUtils/enumerations";

export interface LoginDataProps {
  userIdentity?: string | undefined | FormDataEntryValue | null;
  password?: string | undefined | FormDataEntryValue | null;
  isEncrypted: boolean;
  loginTypeId: number;
}

export interface MfaOtpDataProps {
  userIdentity: string;
  otp: string;
}

export const loginStyle = {
  boxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  backgroundImageContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minHeight: CPSConstants.BGHEIGHT,
    display: "flex",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: CPSConstants.STANDARDCOLOR,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingLeft: "6%",
  },
  userProfileContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: CPSConstants.FORMBGCOLOR,
    borderRadius: CPSConstants.LOGINFORMBORDERRADIUS,
    padding: "0 !important",
    width: CPSConstants.LOGINFORMWIDTH,
    minHeight: CPSConstants.LOGINFORMHEIGHT,
  },
  loginImageBackgroundColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRadius: "0.5rem 0.5rem 0rem 0rem",
    display: "flex",
    justifyContent: "center",
    backgroundColor: CPSConstants.STANDARDCOLOR,
  },
  loginSecondFormStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    mt: "2.25rem",
    borderRadius: CPSConstants.LOGINFORMBORDERRADIUS,
    backgroundColor: CPSConstants.FORMBGCOLOR,
    width: CPSConstants.LOGINFORMWIDTH,
    height: CPSConstants.LOGINSECONDFORMHEIGHT,
  },
  userProfileStyleCpsLogo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: CPSConstants.FORMHEADERLOGOWIDTH,
  },
  loginGridContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-20px",
    p: "2rem 0 0 0",
    "& .MuiGrid-item": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingTop: "15px",
    },
  },
  loginPleaseSignInText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#242A3C",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
    margin: "-1.25rem 0 0 0",
  },
  loginStyleInputLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    margin: "0 0 -0.75rem 0",
    color: "#242A3C",
  },
  loginThreeColumnLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
  },
  loginStyleContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMTEXT,
    padding: "0.625rem 0 0 0",
  },
  loginStyleStack: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    marginBottom: "2rem",
  },
  userProfileButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: CPSConstants.BUTTONBGCOLOR,
  },
  avatarStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    m: 1,
    bgcolor: "primary.main",
  },
  buttonStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: CPSConstants.BUTTONBGCOLOR,
    textTransform: "capitalize",
    fontSize: CPSConstants.FONTREMTEXT,
  },
  copyRightStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    mt: 8,
    mb: 4,
  },
  loginalert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
  },
  loginmuiTextFieldStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiInputLabel-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#242A3C",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#242A3C",
    },
    "& ::placeholder": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
    },
    "& .MuiInputBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "2.188rem",
    },
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderColor: "#b3bfe2",
      },
      "&:hover fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderColor: "#b3bfe2",
      },
    },
    "& .Mui-error": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
    },
  },
  loginTextLebelMuiStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiFormControlLabel-label": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#242A3C",
      fontSize: CPSConstants.FONTREMTEXT,
    },
  },

  loginThreeLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "space-between",
    pt: "0.625rem",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  },
  paddingTopBottom: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem 0rem 0.313rem 0rem",
  },
  loginTwoLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "center",
    paddingBottom: "15px",
  },
  pipe: {
    padding: "3px",
  },
  loginCheckBoxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#949598",
  },
  loginSecondFormTypograpy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
    padding: 1,
    justifyContent: "center",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
  },
  loginLillyLogoStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0.5rem",
    marginTop: "0.5rem",
    width: "5.2rem",
  },
  loginemployeetext: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMHEAD,
    color: "#000000",
  },
  ssoboxClickHereStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMHEAD,
    pl: "0.4rem",
    color: "#275DC6",
  },
  loginformboxlink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "0 0 0 0",
  },
  logincontentbox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "-1.625rem 0px 0px 0px",
  },
  headingtext: {
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMTITLE,
    color: "#000000",
  },
  otpContainer: {
    display: "flex",
    flexDirection: "column",
    alignContent: "space-around",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },
  formLink: {
    fontSize: CPSConstants.FONTREMTEXT,
    pb: "1rem",
  },
  cookieLink: {
    fontSize: CPSConstants.FONTREMTEXT,
    pb: "1rem",
    cursor: "pointer",
    textDecoration: "underline",
  },
  privacyChoiceLogo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "2.5rem",
    paddingRight: "5px",
  },
};
